import { View } from "react-native";
import { Text } from "react-native-paper";
import { useTailwind } from "tailwind-rn";

export default function Disclaimer() {
  const tailwind = useTailwind();
  return (
    <View>
      <Text variant="labelMedium" style={tailwind("m-4")}>
        Todos los logotipos y marcas son propiedad de sus respectivos
        propietarios y son usados únicamente para fines identificativos.
      </Text>
    </View>
  );
}
